import { useEffect } from "react";
import reportWebVitals from "./report-web-vitals";
import trackWebVitals from "./track-web-vitals";

export default function useWebVitals() {
  useEffect(() => {
    reportWebVitals(trackWebVitals);
  }, []);
}
